<p>contract works!</p>
